import { Injectable } from '@angular/core'

import { Observable } from 'rxjs'

import { IApiResponse } from 'app/_shared/interfaces/IApiResponse'

import { ApiService } from './api.service'

@Injectable({
  providedIn: 'root'
})
export class ContactService extends ApiService {
  submitContact(storefrontId: number, formData: FormData): Observable<IApiResponse<any>> {
    return this.post(`${this.apiUrl}/storefronts/${storefrontId}/contact`, formData)
  }
}
